module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_oc-0f44aeba1d862a0a2289bfdce7410a80.gif";